import { createContext } from "react";

export const ProfileContext = createContext({});

export const relevanceIds = [
  "Total_band",
  "DRAVET_SYNDROME_band",
  "LENNOX-GASTAUT_SYNDROME_band",
  "CDD_band",
  "OTHER_band",
];

export const tickHeaders = ["traditionalKol", "twitterHandle", "opinionLeader"];

export const existingColumns = {
  Name: "NAME",
  research_gate: "RESEARCHGATE",
  "Linkedin Handle": "LINKEDIN HANDLE",
  HANDLE: "TWITTER HANDLE",
  DRAVET_SYNDROME_articles: "DRAVET SYNDROME  ARTICLES",
  DRAVET_SYNDROME_ciation: "DRAVET SYNDROME  CITATION",
  "LENNOX-GASTAUT_SYNDROME_articles": "LENNOX-GASTAUT SYNDROME  ARTICLES",
  "LENNOX-GASTAUT_SYNDROME_ciation": "LENNOX-GASTAUT SYNDROME  CITATION",
  CDD_articles: "CDD  ARTICLES",
  CDD_ciation: "CDD  CITATION",
  OTHER_articles: "OTHER  ARTICLES",
  OTHER_ciation: "OTHER  CITATION",
  DRAVET_SYNDROME_trials: "DRAVET SYNDROME  TRIALS",
  "LENNOX-GASTAUT_SYNDROME_trials": "LENNOX-GASTAUT SYNDROME  TRIALS",
  CDD_trials: "CDD  TRIALS",
  OTHER_trials: "OTHER  TRIALS",
  "Total LinkedIn Connections": "TOTAL LINKEDIN CONNECTIONS",
  "Total LinkedIn Followers": "TOTAL LINKEDIN FOLLOWERS",
  "Total LinkedIn Posts": "TOTAL LINKEDIN POSTS",
  Influencing: "INFLUENCING",
  Influencers: "INFLUENCERS",
  "Researchgate Publication Count": "RESEARCHGATE PUBLICATION COUNT",
  "Researchgate Citation Count": "RESEARCHGATE CITATION COUNT",
  TOTAL_TWEETS: "TOTAL TWEETS",
  TWITTER_FOLLOWING: "TWITTER FOLLOWING",
  TWITTER_FOLLOWERS: "TWITTER FOLLOWERS",
  TWITTER_LIKES: "TWITTER LIKES",
};

export const numColumns = [
  "Expertise-Agreement",
  "Scientific Leadership",
  "Digital Value",
  "DRAVET_SYNDROME_articles",
  "DRAVET_SYNDROME_ciation",
  "LENNOX-GASTAUT_SYNDROME_articles",
  "LENNOX-GASTAUT_SYNDROME_ciation",
  "CDD_articles",
  "CDD_ciation",
  "OTHER_articles",
  "OTHER_ciation",
  "DRAVET_SYNDROME_trials",
  "LENNOX-GASTAUT_SYNDROME_trials",
  "CDD_trials",
  "OTHER_trials",
  "TOTAL_TWEETS",
  "TWITTER_FOLLOWING",
  "TWITTER_FOLLOWERS",
  "TWITTER_LIKES",
  "Total LinkedIn Connections",
  "Total LinkedIn Followers",
  "Total LinkedIn Posts",
  "Researchgate Publication Count",
  "Researchgate Citation Count",
];

export const linkColumns = ["research_gate", "Linkedin Handle", "Twitter Handle"];

export const multiItemColumns = ["Influencing", "Influencers"];

export const descStyle = {
  lineHight: "1.5em",
  height: "3em",
  overflow: "hidden",
  textOverflow: "ellipsis",
  width: "100%",
};

export const dropDownOptions = [
  {
    label: "DRAVET SYNDROME",
    value: "dravet syndrome",
  },
  {
    label: "LENNOX GASTAUT SYNDROME",
    value: "lennox gastaut syndrome",
  },
  {
    label: "CDD",
    value: "cdd",
  },
  {
    label: "OTHER",
    value: "other",
  },
];

export const postsMentionsOptions = [
  {
    label: "DS POSTS",
    value: "dravet syndrome posts",
  },
  {
    label: "DS MENTIONS",
    value: "dravet syndrome mentions",
  },
  {
    label: "LGS POSTS",
    value: "lennox gastaut syndrome posts",
  },
  {
    label: "LGS MENTIONS",
    value: "lennox gastaut syndrome mentions",
  },
  {
    label: "CDD POSTS",
    value: "cdd posts",
  },
  {
    label: "CDD MENTIONS",
    value: "cdd mentions",
  },
  {
    label: "OTHER POSTS",
    value: "other posts",
  },
  {
    label: "OTHER MENTIONS",
    value: "other mentions",
  },
];

export const dataProfileList = [
  {
    title: "Trial of Cannabidiol for Drug-Resistant Seizures in the Dravet Syndrome.",
    link: "http://www.hopital-necker.aphp.fr/",
    description:
      "Are you trying to contribute to Open Source Projects but don't know how to find issues or where to start?",
  },
  {
    title: "Trial of Cannabidiol for Drug-Resistant Seizures in the Dravet Syndrome.",
    link: "http://www.hopital-necker.aphp.fr/",
    description:
      "Are you trying to contribute to Open Source Projects but don't know how to find issues or where to start?",
  },
  {
    title: "Trial of Cannabidiol for Drug-Resistant Seizures in the Dravet Syndrome.",
    link: "http://www.hopital-necker.aphp.fr/",
    description:
      "Are you trying to contribute to Open Source Projects but don't know how to find issues or where to start?",
  },
  {
    title: "Trial of Cannabidiol for Drug-Resistant Seizures in the Dravet Syndrome.",
    link: "http://www.hopital-necker.aphp.fr/",
    description:
      "Are you trying to contribute to Open Source Projects but don't know how to find issues or where to start?",
  },
  {
    title: "Trial of Cannabidiol for Drug-Resistant Seizures in the Dravet Syndrome.",
    link: "http://www.hopital-necker.aphp.fr/",
    description:
      "Are you trying to contribute to Open Source Projects but don't know how to find issues or where to start?",
  },
  {
    title: "Trial of Cannabidiol for Drug-Resistant Seizures in the Dravet Syndrome.",
    link: "http://www.hopital-necker.aphp.fr/",
    description:
      "Are you trying to contribute to Open Source Projects but don't know how to find issues or where to start?",
  },
];

export let localColumnWeights = {
  "DRAVET_SYNDROME_score": {
    "DRAVET_SYNDROME Traditional Digital Media Count": 5,
    "DRAVET_SYNDROME Tweets Posted Count": 10,
    "DRAVET_SYNDROME Tweet Mentions": 0,
    "DRAVET_SYNDROME Retweets Posted Count": 10,
    "DRAVET_SYNDROME Retweet Mentions": 0,  
    "DRAVET_SYNDROME LinkedIn Mentions": 0,
    "DRAVET_SYNDROME LinkedIn Posts": 10,
    "DRAVET_SYNDROME Facebook Mentions": 5,
    "DRAVET_SYNDROME YouTube Mentions": 5,
  },
  "LENNOX-GASTAUT_SYNDROME_score": {
    "LENNOX-GASTAUT_SYNDROME Traditional Digital Media Count": 5,
    "LENNOX-GASTAUT_SYNDROME Tweets Posted Count": 10,
    "LENNOX-GASTAUT_SYNDROME Tweet Mentions": 0,
    "LENNOX-GASTAUT_SYNDROME Retweets Posted Count": 10,
    "LENNOX-GASTAUT_SYNDROME Retweet Mentions": 0,
    "LENNOX-GASTAUT_SYNDROME LinkedIn Mentions": 0,
    "LENNOX-GASTAUT_SYNDROME LinkedIn Posts": 10,
    "LENNOX-GASTAUT_SYNDROME Facebook Mentions": 5,
    "LENNOX-GASTAUT_SYNDROME YouTube Mentions": 5,
  },
  "CDD_score": {
    "CDD Traditional Digital Media Count": 5,
    "CDD Tweets Posted Count": 10,
    "CDD Tweet Mentions": 0,
    "CDD Retweets Posted Count": 10,
    "CDD Retweet Mentions": 0,
    "CDD LinkedIn Mentions": 0,
    "CDD LinkedIn Posts": 10,
    "CDD Facebook Mentions": 5,
    "CDD YouTube Mentions": 5,
  },
  "OTHER_score": {
    "OTHER Traditional Digital Media Count": 5,
    "OTHER Tweets Posted Count": 10,
    "OTHER Tweet Mentions": 0,
    "OTHER Retweets Posted Count": 10,
    "OTHER Retweet Mentions": 0,
    "OTHER LinkedIn Mentions": 0,
    "OTHER LinkedIn Posts": 10,
    "OTHER Facebook Mentions": 5,
    "OTHER YouTube Mentions": 5,
  }
};

export let localTotalWeights = {
  "DRAVET_SYNDROME_rank": 10,
  "LENNOX-GASTAUT_SYNDROME_rank": 7,
  "CDD_rank": 7,
  "OTHER_rank": 3.5,
  "RESEARCHER": 7,
  "CLINICIAN": 10,
  "OTHER HCP": 3.5,
  "TWITTER HANDLE": 10
};

export const defaultDropdownValues = {
  twitter: { shouldRender: true, renderValue: { label: "DS MENTIONS", value: "dravet syndrome mentions" } },
  linkedin: { shouldRender: true, renderValue: { label: "DS MENTIONS", value: "dravet syndrome mentions" } },
  facebook: { shouldRender: true, renderValue: { label: "DRAVET SYNDROME", value: "dravet syndrome" } },
  youtube: { shouldRender: true, renderValue: { label: "DRAVET SYNDROME", value: "dravet syndrome" } },
  tMedia: { shouldRender: true, renderValue: { label: "DRAVET SYNDROME", value: "dravet syndrome" } },
};

export const additionalColsLabel = {
  'fullName': 'NAME',
  'COUNTRY': 'COUNTRY',
  'dravet syndrome': 'DRAVET SYNDROME SCIENTIFIC ENGAGEMENT',
  'Publications Count': 'PUBLICATIONS COUNT',
  'Citations Count': 'CITATIONS COUNT',
  'Trials Count': 'CLINICAL TRIALS',
  'secondRow': '',
  'Total_band': 'TOTAL RELEVANCE',
  "grid_name": "AFFILIATION",
  "Type of Organisation": "TYPE OF ORGANISATION",
  "traditionalKol": "TRADITIONAL KOL",
  "twitterHandle": "TWITTER HANDLE",
  "Speciality": "SPECIALITY",
  "PROFESSION": "PROFESSION",
  "Total LinkedIn Posts": "TOTAL LINKEDIN POSTS",
  "Total LinkedIn Connections": "TOTAL LINKEDIN CONNECTIONS",
  "Total LinkedIn Followers": "TOTAL LINKEDIN FOLLOWERS",
  "Total Tweet Posts": "TOTAL TWEET POSTS",
  "Total Twitter Followers": "TOTAL TWITTER FOLLOWERS",
  "ResearchGate Publication Count": "RESEARCHGATE PUBLICATION COUNT",
  "ResearchGate Project Count": "RESEARCHGATE PROJECT COUNT",
  "dravet syndrome engagement": "DRAVET SYNDROME SOCIAL MEDIA ENGAGEMENT",
  "Traditional Digital Media Count": "TRADITIONAL DIGITAL MEDIA COUNT",
  "Tweets Posted Count": "TWEETS POSTED COUNT",
  "Tweet Mentions": "TWEET MENTIONS",
  "Total Tweets": "TOTAL TWEETS",
  "Retweets Posted Count": "RETWEETS POSTED COUNT",
  "Retweet Mentions": "RETWEET MENTIONS",
  "Total Retweets": "TOTAL RETWEETS",
  "LinkedIn Mentions": "LINKEDIN MENTIONS",
  "LinkedIn Posts": "LINKEDIN POSTS",
  "Facebook Mentions": "FACEBOOK MENTIONS",
  "YouTube Mentions": "YOUTUBE MENTIONS",
  "band": "RELEVANCE",
  "lennox syndrome": "LENNOX GASTAUT SYNDROME SCIENTIFIC ENGAGEMENT",
  "lennox syndrome engagement": "LENNOX GASTAUT SYNDROME SOCIAL MEDIA ENGAGEMENT",
  "cdd": "CDD SCIENTIFIC ENGAGEMENT",
  "cdd engagement": "CDD SOCIAL MEDIA ENGAGEMENT",
  "other": "OTHER SCIENTIFIC ENGAGEMENT",
  "other engagement": "OTHER SOCIAL MEDIA ENGAGEMENT"
}

export const additionalCols = {
  'fullName': {
    active: true
  },
  'secondRow': {
    active: true,
    subTabs: {
      'Total_band': {
        active: true,
      },
      'grid_name': {
        active: true,
      },
      "Type of Organisation": {
        active: true
      },
      "COUNTRY": {
        active: true
      },
      "traditionalKol": {
        active: true
      }

      ,
      "twitterHandle": {
        active: true
      }

      ,
      "Speciality": {
        active: true
      },

      "PROFESSION": {
        active: true
      }
      ,

      "Total LinkedIn Posts": {
        active: true
      }


      ,
      "Total LinkedIn Connections": {
        active: true
      }

      ,
      "Total LinkedIn Followers": {
        active: true
      }
      ,
      "Total Tweet Posts": {
        active: true
      }

      ,
      "Total Twitter Followers": {
        active: true
      }


      ,
      "Total Tweet Posts": {
        active: true
      }

      ,
      "ResearchGate Publication Count": {
        active: true
      }

      ,
      "ResearchGate Project Count": {
        active: true
      },

    }
  },

  'dravet syndrome': {
    active: true,
    subTabs: {
      'DRAVET_SYNDROME Publications Count': {
        active: true
      },
      'DRAVET_SYNDROME Citations Count': {
        active: true
      },
      'DRAVET_SYNDROME Trials Count': {
        active: true
      }
    }
  },


  "dravet syndrome engagement": {
    active: true,
    subTabs: {
      'DRAVET_SYNDROME Traditional Digital Media Count': {
        active: true
      },
      "DRAVET_SYNDROME Tweets Posted Count": {
        active: true
      },

      "DRAVET_SYNDROME Tweet Mentions": {
        active: true
      },

      "DRAVET_SYNDROME Total Tweets": {
        active: true
      },
      "DRAVET_SYNDROME Retweets Posted Count": {
        active: true
      },
      "DRAVET_SYNDROME Retweet Mentions": {
        active: true
      }

      ,
      "DRAVET_SYNDROME Total Retweets": {
        active: true
      }

      ,
      "DRAVET_SYNDROME LinkedIn Mentions": {
        active: true
      }

      ,
      "DRAVET_SYNDROME LinkedIn Posts": {
        active: true
      }

      ,
      "DRAVET_SYNDROME Facebook Mentions": {
        active: true
      }

      ,
      "DRAVET_SYNDROME YouTube Mentions": {
        active: true
      }

      ,
      "DRAVET_SYNDROME_band": {
        active: true
      }
    }
  },


  'lennox syndrome': {
    active: true,
    subTabs: {
      'LENNOX-GASTAUT_SYNDROME Publications Count': {
        active: true
      },
      'LENNOX-GASTAUT_SYNDROME Citations Count': {
        active: true
      },
      'LENNOX-GASTAUT_SYNDROME Trials Count': {
        active: true
      }
    }
  },


  "lennox syndrome engagement": {
    active: true,
    subTabs: {
      'LENNOX-GASTAUT_SYNDROME Traditional Digital Media Count': {
        active: true
      },
      "LENNOX-GASTAUT_SYNDROME Tweets Posted Count": {
        active: true
      },

      "LENNOX-GASTAUT_SYNDROME Tweet Mentions": {
        active: true
      },

      "LENNOX-GASTAUT_SYNDROME Total Tweets": {
        active: true
      },
      "LENNOX-GASTAUT_SYNDROME Retweets Posted Count": {
        active: true
      },
      "LENNOX-GASTAUT_SYNDROME Retweet Mentions": {
        active: true
      }

      ,
      "LENNOX-GASTAUT_SYNDROME Total Retweets": {
        active: true
      }

      ,
      "LENNOX-GASTAUT_SYNDROME LinkedIn Mentions": {
        active: true
      }

      ,
      "LENNOX-GASTAUT_SYNDROME LinkedIn Posts": {
        active: true
      }

      ,
      "LENNOX-GASTAUT_SYNDROME Facebook Mentions": {
        active: true
      }

      ,
      "LENNOX-GASTAUT_SYNDROME YouTube Mentions": {
        active: true
      }

      ,
      "LENNOX-GASTAUT_SYNDROME_band": {
        active: true
      }
    }
  },


  'cdd': {
    active: true,
    subTabs: {
      'CDD Publications Count': {
        active: true
      },
      'CDD Citations Count': {
        active: true
      },
      'CDD Trials Count': {
        active: true
      }
    }
  },


  "cdd engagement": {
    active: true,
    subTabs: {
      'CDD Traditional Digital Media Count': {
        active: true
      },
      "CDD Tweets Posted Count": {
        active: true
      },

      "CDD Tweet Mentions": {
        active: true
      },

      "CDD Total Tweets": {
        active: true
      },
      "CDD Retweets Posted Count": {
        active: true
      },
      "CDD Retweet Mentions": {
        active: true
      }

      ,
      "CDD Total Retweets": {
        active: true
      }

      ,
      "CDD LinkedIn Mentions": {
        active: true
      }

      ,
      "CDD LinkedIn Posts": {
        active: true
      }

      ,
      "CDD Facebook Mentions": {
        active: true
      }

      ,
      "CDD YouTube Mentions": {
        active: true
      }

      ,
      "CDD_band": {
        active: true
      }
    }
  },


  'other': {
    active: true,
    subTabs: {
      'OTHER Publications Count': {
        active: true
      },
      'OTHER Citations Count': {
        active: true
      },
      'OTHER Trials Count': {
        active: true
      }
    }
  },


  "other engagement": {
    active: true,
    subTabs: {
      'OTHER Traditional Digital Media Count': {
        active: true
      },
      "OTHER Tweets Posted Count": {
        active: true
      },

      "OTHER Tweet Mentions": {
        active: true
      },

      "OTHER Total Tweets": {
        active: true
      },
      "OTHER Retweets Posted Count": {
        active: true
      },
      "OTHER Retweet Mentions": {
        active: true
      }

      ,
      "OTHER Total Retweets": {
        active: true
      }

      ,
      "OTHER LinkedIn Mentions": {
        active: true
      }

      ,
      "OTHER LinkedIn Posts": {
        active: true
      }

      ,
      "OTHER Facebook Mentions": {
        active: true
      }

      ,
      "OTHER YouTube Mentions": {
        active: true
      }

      ,
      "OTHER_band": {
        active: true
      }
    }
  },

};

export const preservedFields = ['fullName'];


export const monthsMapping = {
  '01': 'Jan',
  '02': 'Feb',
  '03': 'Mar',
  '04': 'Apr',
  '05': 'May',
  '06': 'Jun',
  '07': 'Jul',
  '08': 'Aug',
  '09': 'Sep',
  '10': 'Oct',
  '11': 'Nov',
  '12': 'Dec'
};

export const monthsPosition = {
  'Jan': 0,
  'Feb': 1,
  'Mar': 2,
  'Apr': 3,
  'May': 4,
  'Jun': 5,
  'Jul': 6,
  'Aug': 7,
  'Sep': 8,
  'Oct': 9,
  'Nov': 10,
  'Dec': 11
};

export const specialityMapping = {'PSYCHIATRY': ['PSYCHIATRY', 'NEUROPSYCHIATRY'],
'PSYCHIATRIC DISORDERS': ['PSYCHIATRIC DISORDERS'],
'PAEDIATRICS': ['PAEDIATRICS, EPILEPSY', 'PAEDIATRICS'],
'NEUROSCIENCE': ['NEUROSCIENCE'],
'BIPOLAR AND DEPRESSIVE DISORDERS': ['BIPOLAR AND DEPRESSIVE DISORDERS'],
'EPIGENETICS': ['EPIGENETICS'],
'MEDICINE, SURGERY': ['MEDICINE, SURGERY'],
'NANO-SCIENCE': ['NANO-SCIENCE'],
'RADIODIAGNOSIS': ['RADIODIAGNOSIS'],
'PAEDIATRIC NEUROLOGY': ['PAEDIATRIC NEUROLOGY, EPILEPSY',
 'PAEDIATRIC NEUROLOGY AND NEUROPSYCHOLOGY',
 'PAEDIATRIC NEUROLOGY'],
'NEUROLOGY': ['NEUROLOGY, PAEDIATRIC EPILEPSY',
 'NEUROLOGY',
 'NEUROLOGY, EPILEPSY',
 'NEUROLOGY, NEUROPHYSIOLOGY'],
'EPILEPSY': ['NEUROPHYSIOLOGY, EPILEPSY',
 'NEUROLOGY, EPILEPSY',
 'NEUROLOGY, PAEDIATRIC EPILEPSY',
 'EPILEPSY',
 'PAEDIATRICS, EPILEPSY'],
'NEUROBIOLOGY': ['NEUROBIOLOGY'],
'NEURODEGENERATIVE': ['NEURODEGENERATIVE'],
'NEUROPHYSIOLOGY': ['NEUROPHYSIOLOGY, EPILEPSY',
 'NEUROPHYSIOLOGY',
 'PAEDIATRIC NEUROLOGY AND NEUROPSYCHOLOGY'],
'PSYCHOLOGY': ['CLINICAL PSYCHOLOGY',
 'PSYCHOLOGY',
 'CLINICAL NEUROPSYCHOLOGY'],
'NEUROPSYCHOLOGY': ['NEUROPSYCHOLOGY',
 'CLINICAL NEUROPSYCHOLOGY'],
'BIOLOGY, GENETICS': ['BIOLOGY, GENETICS'],
'CLINICAL GENETICS': ['CLINICAL GENETICS'],
'GENE THERAPY': ['GENE THERAPY']}

export const specialityOptions = {
  
'GENETICS': {'active': false,
'subTabs': {'BIOLOGY, GENETICS': {'active': false},
 'CLINICAL GENETICS': {'active': false},
 'GENE THERAPY': {'active': false}}},

 'NEUROLOGY': {'active': false,
'subTabs': {'EPILEPSY': {'active': false},
 'NEUROBIOLOGY': {'active': false},
 'NEURODEGENERATIVE': {'active': false},
 'NEUROLOGY': {'active': false},
 'NEUROPHYSIOLOGY': {'active': false},
 'PAEDIATRIC NEUROLOGY': {'active': false}}},

 'OTHER': {'active': false,
'subTabs': {'BIPOLAR AND DEPRESSIVE DISORDERS': {'active': false},
 'EPIGENETICS': {'active': false},
 'MEDICINE, SURGERY': {'active': false},
 'NANO-SCIENCE': {'active': false},
 'NEUROSCIENCE': {'active': false},
 'PAEDIATRICS': {'active': false},
 'RADIODIAGNOSIS': {'active': false}}},

  'PSYCHIATRY': {'active': false,
'subTabs': {'PSYCHIATRIC DISORDERS': {'active': false},
 'PSYCHIATRY': {'active': false}}},

'PSYCHOLOGY': {'active': false,
'subTabs': {'NEUROPSYCHOLOGY': {'active': false},
 'PSYCHOLOGY': {'active': false}}},
}

export const specialityLabels = {'PSYCHIATRY': 'PSYCHIATRY',
'NEUROPSYCHIATRY': 'NEUROPSYCHIATRY',
'PSYCHIATRIC DISORDERS': 'PSYCHIATRIC DISORDERS',
'PAEDIATRICS': 'PAEDIATRICS',
'OTHER': 'OTHER',
'PAEDIATRICS, EPILEPSY': 'PAEDIATRICS, EPILEPSY',
'NEUROSCIENCE': 'NEUROSCIENCE',
'BIPOLAR AND DEPRESSIVE DISORDERS': 'BIPOLAR AND DEPRESSIVE DISORDERS',
'EPIGENETICS': 'EPIGENETICS',
'MEDICINE, SURGERY': 'MEDICINE, SURGERY',
'NANO-SCIENCE': 'NANO-SCIENCE',
'RADIODIAGNOSIS': 'RADIODIAGNOSIS',
'PAEDIATRIC NEUROLOGY': 'PAEDIATRIC NEUROLOGY',
'NEUROLOGY': 'NEUROLOGY',
'PAEDIATRIC NEUROLOGY, EPILEPSY': 'PAEDIATRIC NEUROLOGY, EPILEPSY',
'PAEDIATRIC NEUROLOGY AND NEUROPSYCHOLOGY': 'PAEDIATRIC NEUROLOGY AND NEUROPSYCHOLOGY',
'NEUROLOGY, PAEDIATRIC EPILEPSY': 'NEUROLOGY, PAEDIATRIC EPILEPSY',
'NEUROLOGY, EPILEPSY': 'NEUROLOGY, EPILEPSY',
'NEUROLOGY, NEUROPHYSIOLOGY': 'NEUROLOGY, NEUROPHYSIOLOGY',
'EPILEPSY': 'EPILEPSY',
'NEUROPHYSIOLOGY, EPILEPSY': 'NEUROPHYSIOLOGY, EPILEPSY',
'NEUROBIOLOGY': 'NEUROBIOLOGY',
'NEURODEGENERATIVE': 'NEURODEGENERATIVE',
'NEUROPHYSIOLOGY': 'NEUROPHYSIOLOGY',
'PSYCHOLOGY': 'PSYCHOLOGY',
'CLINICAL PSYCHOLOGY': 'CLINICAL PSYCHOLOGY',
'CLINICAL NEUROPSYCHOLOGY': 'CLINICAL NEUROPSYCHOLOGY',
'NEUROPSYCHOLOGY': 'NEUROPSYCHOLOGY',
'BIOLOGY, GENETICS': 'BIOLOGY, GENETICS',
'GENETICS': 'GENETICS',
'CLINICAL GENETICS': 'CLINICAL GENETICS',
'GENE THERAPY': 'GENE THERAPY'};

let profession = [
  'CLINICIAN',
  'RESEARCHER',
  'OTHER HCP'
];
export const professionOptions = {};
export const professionLabels = {};
profession.forEach(l => {
  professionLabels[l] = l;
  professionOptions[l] = {
    active: false
  }
});